import { productFormsMachineEvents } from '../../constants/formMachineConstants';
import {
  GoToOTPVerificationEvent,
  ProductFormsMachineEvent,
  SendBackendSegmentEvent,
  SendFrontendSegmentEvent,
  SendGAEvent
} from '../../machines/PublicFormsMachine/types';

export const getEventDetailsFromEventName = (
  eventName: string,
  formValues?: Record<string, any>
): ProductFormsMachineEvent => {
  if (eventName === productFormsMachineEvents.goToOtpVerificationStep) {
    return {
      type: productFormsMachineEvents.goToOtpVerificationStep,
      values: {
        phoneNumber: formValues?.['phone']
      }
    } as GoToOTPVerificationEvent;
  } else if (eventName.includes('SEND_GA_EVENT')) {
    const event = {
      type: 'SEND_GA_EVENT',
      eventName: eventName.replace('SEND_GA_EVENT_', '')
    } as SendGAEvent;
    return event;
  } else if (eventName.includes('SEND_FRONTEND_SEGMENT_EVENT')) {
    const event = {
      type: 'SEND_FRONTEND_SEGMENT_EVENT',
      eventName: eventName.replace('SEND_FRONTEND_SEGMENT_EVENT_', '')
    } as SendFrontendSegmentEvent;
    return event;
  } else if (eventName.includes('SEND_BACKEND_SEGMENT_EVENT')) {
    const event = {
      type: 'SEND_BACKEND_SEGMENT_EVENT',
      eventName: eventName.replace('SEND_BACKEND_SEGMENT_EVENT_', '')
    } as SendBackendSegmentEvent;
    return event;
  } else {
    return { type: eventName } as ProductFormsMachineEvent;
  }
};
